// Toggle swatch expansion without forcing inline styles
document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-expand-swatches]');
  if (!btn) return;

  const wrap = btn.closest('[data-collection-prod-swatches]');
  if (!wrap) return;

  // Flip expanded state
  const expanded = !wrap.classList.contains('is-expanded');
  wrap.classList.toggle('is-expanded', expanded);
  btn.setAttribute('aria-expanded', String(expanded));

  // Update button label
  const remainder = btn.getAttribute('data-remainder') || '';
  btn.textContent = expanded ? 'Show less' : `+${remainder} more`;
});
